import { DollarSign } from "lucide-react";
import DynamicReport from "../../../components/reports/DynamicReport";
import {
  donationReportConfig,
  hydrateDonationReportFilters,
} from "../../../config/reportConfigs";

export default function DonationReport() {
  return (
    <DynamicReport
      config={donationReportConfig}
      icon={DollarSign}
      hydrateFilters={rows => hydrateDonationReportFilters(rows)}
    />
  );
}
